module.exports = __webpack_public_path__ + "img/m-zichanguanli.83c47bc2.svg";